export default "__VITE_ASSET__D4hESIuU__"